export const handleModal = (event: any) => {
  // event?.stopPropagation()
  const target = event?.target?.nodeName == 'IMG' ? event?.currentTarget : event?.target
  if (target?.hasAttribute('data-link-type') && target?.getAttribute('data-link-type') === 'modal') {
    event?.preventDefault()
    const modalId = target?.getAttribute('href')?.split('#')?.[1]
    const customEvent = new CustomEvent('showModal', { detail: { modalId: modalId, showModal: true } })
    window.dispatchEvent(customEvent)

    return false
  }
}
